<template>
  <div class>
    <Modal
        v-model="show"
        title=""
        class="modal"
        width="430"
        :mask-closable="false"
        @on-ok="ok"
        @on-cancel="cancel">
        <div slot="header" style="text-align:center" class="title">
          用户登录
        </div>
        <Form ref="form" :model="formItem" :rules="ruleLogin">
            <FormItem prop="loginName">
                <Input type="text" v-model="formItem.loginName" placeholder="请输入您的手机号" />
            </FormItem>
            <FormItem prop="loginPass">
                <Input type="password" v-model="formItem.loginPass" :maxlength="30" placeholder="请输入您的密码" />
            </FormItem>
        </Form>
        <div slot="footer">
            <Button type="error" size="large" long :loading="loading" @click="submit">登录</Button>
            <div class="link-wrap">
              <div class="link-txt" @click="toForget">忘记密码？</div>
              <div>没有账户？<span class="link-txt" @click="toReg">立即注册</span></div>
            </div>
        </div>
    </Modal>
  </div>
</template>

<script>
import { apiGet, apiPost } from "@/fetch/api";
import enscrypt_RSA from '@/common/encrypt';
import tools from '@/utils/tools'
import { mapActions } from "vuex";

export default {
  components:{},
  inject:['reload'],
  props: {
    value: {
      type: Boolean,
      default: false,
    }
  },
  filters:{},
  data(){
    return {
      show: this.value,
      loading: false,
      formItem:{
        loginName:'',
        loginPass: '',
      },
      ruleLogin: {
        loginName: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          // { validator: tools.validate.phone, message: '手机号格式不正确', trigger: 'blur' }
        ],
        loginPass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          // { validator: tools.validate.stringCheck, message: '密码格式不正确', trigger: 'blur' },
        ],
      }
    }
  },
  watch:{
    value: {
      handler(val){
        this.show = val;
        if(val){
           this.formItem = {
            loginName:'',
            loginPass: '',
          }
          this.$nextTick(()=>{
            this.$refs.form.resetFields();
          })
        }
       
      },
      immediate: true,
    }
  },
  computed:{},
  created(){},
  mounted(){
  },
  methods:{
    ...mapActions(['setTokenInfo', 'userInfoCon']),
    ok(){
      this.show = false;
      this.$emit('input',false);
      this.$store.state.loginShow = false;
    },
    cancel(){
      this.show = false;
      this.$emit('input',false);
      this.$store.state.loginShow = false;
    },
    // 忘记密码
    toForget(){
      this.$emit('handleModifyPas');
    },
    // 立即注册
    toReg(){
      this.$emit('handleReg');
    },
    async leaguerInfo() {
      let res = await apiGet("/leaguer/api/userLeaguer/manage/leaguerInfo", {
        merchantInfoId: this.$route.query.m_id,
        leaguerId: localStorage.getItem('xjsc_login_userId_2019_3_8'),
      });
      if(Number(res.status) === 200){
        this.$store.dispatch('updateUserInfo', res.data)
        // localStorage.setItem('user_info_20201231', JSON.stringify(res.data))
        console.log('res.data',res.data)
        this.userInfoCon(res.data);
        this.$store.dispatch('updateLoginShow', false)
        this.$store.dispatch('updateLogin', true)
        this.reload();
      }else{
        this.$Message.warning(res.message)
      }
    },
    submit(){
      this.$refs.form.validate(valid=>{
        if(!valid) return;
        this.loading = true;
        apiGet("/leaguer/api/userLeaguer/leaguerLogin", {
          loginName: this.formItem.loginName,
          loginPass: enscrypt_RSA.toRSAcode(this.formItem.loginPass),
          merchantInfoId: this.$route.query.m_id || localStorage.getItem('m_id'),
        }).then(async res => {
          if(Number(res.status) === 200){
            this.cancel();
            // localStorage.setItem("xjsc_login_access_token_2019_3_7", res.data.token);
            this.setTokenInfo(res.data.token)
            localStorage.setItem("xjsc_login_userId_2019_3_8", res.data.leaguerId);
            await this.leaguerInfo();
            location.reload();
            this.$Message.success("登录成功！");
            this.$store.state.login = false;
            this.$store.dispatch('updateLoginShow', false)
            let getNext = localStorage.getItem('nextPath')||'/';
            if(getNext){
              this.$router.push({path:getNext,query:this.$route.query});
            }
          }else{
            this.$Message.warning(res.message)
          }
          this.loading = false;
        });
      })
    }
  }
}
</script>
<style lang="scss">
.modal{
  font-family: PingFang SC;
  .ivu-modal-header{
    border-bottom: none;
  }
  .ivu-modal-body{
    padding: 0 29px;
  }
  .ivu-modal-footer{
    border-top: none;
    padding: 12px 29px;
  }
  .ivu-input{
    height: 34px;
  }
  .title{
    padding: 13px 0;
    font-size: 20px;
    color: #333;
    font-weight: bold;
  }
  .link-wrap{
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    .link-txt{
      color: #f16543;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/modal/login.vue